module.exports = __webpack_public_path__ + "img/39_23.8a9e342c.png";